export function Terms() {
  return (
    <div className="light-island min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .terms-body, .terms-body * {
                background: transparent !important;
              }
              .terms-title, .terms-title * {
                font-family: Arial !important;
                font-size: 26px !important;
                color: #000000 !important;
              }
              .terms-subtitle, .terms-subtitle * {
                font-family: Arial !important;
                color: #595959 !important;
                font-size: 14px !important;
              }
              .terms-heading-1, .terms-heading-1 * {
                font-family: Arial !important;
                font-size: 19px !important;
                color: #000000 !important;
              }
              .terms-heading-2, .terms-heading-2 * {
                font-family: Arial !important;
                font-size: 17px !important;
                color: #000000 !important;
              }
              .terms-body-text, .terms-body-text * {
                color: #595959 !important;
                font-size: 14px !important;
                font-family: Arial !important;
              }
              .terms-link, .terms-link * {
                color: #3030F1 !important;
                font-size: 14px !important;
                font-family: Arial !important;
                word-break: break-word !important;
              }
              .terms-container ul {
                list-style-type: square;
              }
              .terms-container ul > li > ul {
                list-style-type: circle;
              }
              .terms-container ul > li > ul > li > ul {
                list-style-type: square;
              }
              .terms-container ol li {
                font-family: Arial;
              }
            `,
          }}
        />
        <div className="terms-body terms-container">
          <div className="text-left">
            <div className="terms-title" style={{ lineHeight: 1.5 }}>
              <strong>TERMS OF USE</strong>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-subtitle" style={{ lineHeight: 1.5 }}>
              <strong>Last updated</strong> <strong>February 5, 2026</strong>
            </div>
            <div style={{ lineHeight: 1.1 }}>
              <br />
            </div>
            <div style={{ lineHeight: "115%" }}>
              <br />
            </div>
            <div style={{ lineHeight: "115%" }}>
              <br />
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <strong>
                <span className="terms-heading-1">
                  AGREEMENT TO OUR LEGAL TERMS
                </span>
              </strong>
            </div>
          </div>
          <div style={{ lineHeight: 1 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                We are Midship Inc. (&quot;Company,&quot; &quot;we,&quot;
                &quot;us,&quot; &quot;our&quot;).
              </span>
            </div>
          </div>
          <div style={{ lineHeight: 1 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                We operate, as well as any other related products and services
                that refer or link to these legal terms (the &quot;Legal
                Terms&quot;) (collectively, the &quot;Services&quot;).
              </span>
            </div>
            <div style={{ lineHeight: 1 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                You can contact us by email at{" "}
                <a className="terms-link" href="mailto:founders@midship.ai">
                  founders@midship.ai
                </a>{" "}
                or by mail to 303 Sacramento St 3rd floor, San Francisco, CA
                94111, USA, SF, CA 94111, United States.
              </span>
            </div>
            <div style={{ lineHeight: 1 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                These Legal Terms constitute a legally binding agreement made
                between you, whether personally or on behalf of an entity
                (&quot;you&quot;), and Midship Inc., concerning your access to
                and use of the Services. You agree that by accessing the
                Services, you have read, understood, and agreed to be bound by
                all of these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE
                LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE
                SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
              </span>
            </div>
            <div style={{ lineHeight: 1 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                Supplemental terms and conditions or documents that may be
                posted on the Services from time to time are hereby expressly
                incorporated herein by reference. We reserve the right, in our
                sole discretion, to make changes or modifications to these Legal
                Terms at any time and for any reason. We will alert you about
                any changes by updating the &quot;Last updated&quot; date of
                these Legal Terms, and you waive any right to receive specific
                notice of each such change. It is your responsibility to
                periodically review these Legal Terms to stay informed of
                updates. You will be subject to, and will be deemed to have been
                made aware of and to have accepted, the changes in any revised
                Legal Terms by your continued use of the Services after the date
                such revised Legal Terms are posted.
              </span>
            </div>
          </div>
          <div style={{ lineHeight: 1 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              We recommend that you print a copy of these Legal Terms for your
              records.
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-heading-1" style={{ lineHeight: 1.5 }}>
              <strong>TABLE OF CONTENTS</strong>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#services">
                <span className="terms-body-text">1. OUR SERVICES</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#ip">
                <span className="terms-body-text">
                  2. INTELLECTUAL PROPERTY RIGHTS
                </span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#userreps">
                <span className="terms-body-text">3. USER REPRESENTATIONS</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#prohibited">
                <span className="terms-body-text">
                  4. PROHIBITED ACTIVITIES
                </span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#ugc">
                <span className="terms-body-text">
                  5. USER GENERATED CONTRIBUTIONS
                </span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#license">
                <span className="terms-body-text">6. CONTRIBUTION LICENSE</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#sitemanage">
                <span className="terms-body-text">7. SERVICES MANAGEMENT</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#terms">
                <span className="terms-body-text">8. TERM AND TERMINATION</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#modifications">
                <span className="terms-body-text">
                  9. MODIFICATIONS AND INTERRUPTIONS
                </span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#law">
                <span className="terms-body-text">10. GOVERNING LAW</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#disputes">
                <span className="terms-body-text">11. DISPUTE RESOLUTION</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#corrections">
                <span className="terms-body-text">12. CORRECTIONS</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#disclaimer">
                <span className="terms-body-text">13. DISCLAIMER</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#liability">
                <span className="terms-body-text">
                  14. LIMITATIONS OF LIABILITY
                </span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#indemnification">
                <span className="terms-body-text">15. INDEMNIFICATION</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#userdata">
                <span className="terms-body-text">16. USER DATA</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#electronic">
                <span className="terms-body-text">
                  17. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
                </span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#misc">
                <span className="terms-body-text">18. MISCELLANEOUS</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <a className="terms-link" href="#contact">
                <span className="terms-body-text">19. CONTACT US</span>
              </a>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div
              className="terms-heading-1"
              id="services"
              style={{ lineHeight: 1.5 }}
            >
              <strong>1. OUR SERVICES</strong>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              The information provided when using the Services is not intended
              for distribution to or use by any person or entity in any
              jurisdiction or country where such distribution or use would be
              contrary to law or regulation or which would subject us to any
              registration requirement within such jurisdiction or country.
              Accordingly, those persons who choose to access the Services from
              other locations do so on their own initiative and are solely
              responsible for compliance with local laws, if and to the extent
              local laws are applicable.
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
          </div>
          <div className="text-left">
            <div
              className="terms-heading-1"
              id="ip"
              style={{ lineHeight: 1.5 }}
            >
              <strong>2. INTELLECTUAL PROPERTY RIGHTS</strong>
            </div>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-heading-2" style={{ lineHeight: 1.5 }}>
              <strong>Our intellectual property</strong>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                We are the owner or the licensee of all intellectual property
                rights in our Services, including all source code, databases,
                functionality, software, website designs, audio, video, text,
                photographs, and graphics in the Services (collectively, the
                &quot;Content&quot;), as well as the trademarks, service marks,
                and logos contained therein (the &quot;Marks&quot;).
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                Our Content and Marks are protected by copyright and trademark
                laws (and various other intellectual property rights and unfair
                competition laws) and treaties around the world.
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                The Content and Marks are provided in or through the Services
                &quot;AS IS&quot; for your personal, non-commercial use or
                internal business purpose only.
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-heading-2" style={{ lineHeight: 1.5 }}>
              <strong>Your use of our Services</strong>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              Subject to your compliance with these Legal Terms, including the{" "}
              <a className="terms-link" href="#prohibited">
                PROHIBITED ACTIVITIES
              </a>{" "}
              section below, we grant you a non-exclusive, non-transferable,
              revocable license to:
            </div>
            <ul>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                access the Services; and
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                download or print a copy of any portion of the Content to which
                you have properly gained access,
              </li>
            </ul>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                solely for your personal, non-commercial use or internal
                business purpose.
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                Except as set out in this section or elsewhere in our Legal
                Terms, no part of the Services and no Content or Marks may be
                copied, reproduced, aggregated, republished, uploaded, posted,
                publicly displayed, encoded, translated, transmitted,
                distributed, sold, licensed, or otherwise exploited for any
                commercial purpose whatsoever, without our express prior written
                permission.
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                If you wish to make any use of the Services, Content, or Marks
                other than as set out in this section or elsewhere in our Legal
                Terms, please address your request to:{" "}
                <a className="terms-link" href="mailto:founders@midship.ai">
                  founders@midship.ai
                </a>
                . If we ever grant you the permission to post, reproduce, or
                publicly display any part of our Services or Content, you must
                identify us as the owners or licensors of the Services, Content,
                or Marks and ensure that any copyright or proprietary notice
                appears or is visible on posting, reproducing, or displaying our
                Content.
              </span>
            </div>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                We reserve all rights not expressly granted to you in and to the
                Services, Content, and Marks.
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                Any breach of these Intellectual Property Rights will constitute
                a material breach of our Legal Terms and your right to use our
                Services will terminate immediately.
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-heading-2" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                <strong>Your submissions</strong>
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              Please review this section and the{" "}
              <a className="terms-link" href="#prohibited">
                PROHIBITED ACTIVITIES
              </a>{" "}
              section carefully prior to using our Services to understand the
              (a) rights you give us and (b) obligations you have when you post
              or upload any content through the Services.
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <strong>Submissions:</strong> By directly sending us any question,
              comment, suggestion, idea, feedback, or other information about
              the Services (&quot;Submissions&quot;), you agree to assign to us
              all intellectual property rights in such Submission. You agree
              that we shall own this Submission and be entitled to its
              unrestricted use and dissemination for any lawful purpose,
              commercial or otherwise, without acknowledgment or compensation to
              you.
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <strong>You are responsible for what you post or upload:</strong>{" "}
              By sending us Submissions through any part of the Services you:
            </div>
            <ul>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                confirm that you have read and agree with our{" "}
                <a className="terms-link" href="#prohibited">
                  PROHIBITED ACTIVITIES
                </a>{" "}
                and will not post, send, publish, upload, or transmit through
                the Services any Submission that is illegal, harassing, hateful,
                harmful, defamatory, obscene, bullying, abusive, discriminatory,
                threatening to any person or group, sexually explicit, false,
                inaccurate, deceitful, or misleading;
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                to the extent permissible by applicable law, waive any and all
                moral rights to any such Submission;
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                warrant that any such Submission are original to you or that you
                have the necessary rights and licenses to submit such
                Submissions and that you have full authority to grant us the
                above-mentioned rights in relation to your Submissions; and
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                warrant and represent that your Submissions do not constitute
                confidential information.
              </li>
            </ul>
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              You are solely responsible for your Submissions and you expressly
              agree to reimburse us for any and all losses that we may suffer
              because of your breach of (a) this section, (b) any third
              party&apos;s intellectual property rights, or (c) applicable law.
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
          </div>
          <div className="text-left">
            <div
              className="terms-heading-1"
              id="userreps"
              style={{ lineHeight: 1.5 }}
            >
              <strong>3. USER REPRESENTATIONS</strong>
            </div>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "115%",
                  fontFamily: "Arial",
                  color: "#595959",
                }}
              >
                By using the Services, you represent and warrant that:
              </span>{" "}
              <span style={{ color: "rgb(89, 89, 89)", fontSize: "11pt" }}>
                (1) you have the legal capacity and you agree to comply with
                these Legal Terms;
              </span>{" "}
              <span style={{ color: "rgb(89, 89, 89)", fontSize: "11pt" }}>
                (2) you are not a minor in the jurisdiction in which you reside;
                (3) you will not access the Services through automated or
                non-human means, whether through a bot, script or otherwise; (4)
                you will not use the Services for any illegal or unauthorized
                purpose; and (5) your use of the Services will not violate any
                applicable law or regulation.
              </span>
            </div>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "16.8667px",
                  color: "rgb(89, 89, 89)",
                }}
              >
                If you provide any information that is untrue, inaccurate, not
                current, or incomplete, we have the right to suspend or
                terminate your account and refuse any and all current or future
                use of the Services (or any portion thereof).
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div
              className="terms-heading-1"
              id="prohibited"
              style={{ lineHeight: 1.5 }}
            >
              <strong>4. PROHIBITED ACTIVITIES</strong>
            </div>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "16.8667px",
                  color: "rgb(89, 89, 89)",
                }}
              >
                You may not access or use the Services for any purpose other
                than that for which we make the Services available. The Services
                may not be used in connection with any commercial endeavors
                except those that are specifically endorsed or approved by us.
              </span>
            </div>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "16.8667px",
                  color: "rgb(89, 89, 89)",
                }}
              >
                As a user of the Services, you agree not to:
              </span>
            </div>
            <ul>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Systematically retrieve data or other content from the Services
                to create or compile, directly or indirectly, a collection,
                compilation, database, or directory without written permission
                from us.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Trick, defraud, or mislead us and other users, especially in any
                attempt to learn sensitive account information such as user
                passwords.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Circumvent, disable, or otherwise interfere with
                security-related features of the Services, including features
                that prevent or restrict the use or copying of any Content or
                enforce limitations on the use of the Services and/or the
                Content contained therein.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Disparage, tarnish, or otherwise harm, in our opinion, us and/or
                the Services.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Use any information obtained from the Services in order to
                harass, abuse, or harm another person.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Make improper use of our support services or submit false
                reports of abuse or misconduct.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Use the Services in a manner inconsistent with any applicable
                laws or regulations.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Engage in unauthorized framing of or linking to the Services.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Upload or transmit (or attempt to upload or to transmit)
                viruses, Trojan horses, or other material, including excessive
                use of capital letters and spamming (continuous posting of
                repetitive text), that interferes with any party&apos;s
                uninterrupted use and enjoyment of the Services or modifies,
                impairs, disrupts, alters, or interferes with the use, features,
                functions, operation, or maintenance of the Services.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Engage in any automated use of the system, such as using scripts
                to send comments or messages, or using any data mining, robots,
                or similar data gathering and extraction tools.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Delete the copyright or other proprietary rights notice from any
                Content.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Attempt to impersonate another user or person or use the
                username of another user.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Upload or transmit (or attempt to upload or to transmit) any
                material that acts as a passive or active information collection
                or transmission mechanism, including without limitation, clear
                graphics interchange formats (&quot;gifs&quot;), 1×1 pixels, web
                bugs, cookies, or other similar devices (sometimes referred to
                as &quot;spyware&quot; or &quot;passive collection
                mechanisms&quot; or &quot;pcms&quot;).
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Interfere with, disrupt, or create an undue burden on the
                Services or the networks or services connected to the Services.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Harass, annoy, intimidate, or threaten any of our employees or
                agents engaged in providing any portion of the Services to you.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Attempt to bypass any measures of the Services designed to
                prevent or restrict access to the Services, or any portion of
                the Services.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Copy or adapt the Services&apos; software, including but not
                limited to Flash, PHP, HTML, JavaScript, or other code.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Except as permitted by applicable law, decipher, decompile,
                disassemble, or reverse engineer any of the software comprising
                or in any way making up a part of the Services.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Except as may be the result of standard search engine or
                Internet browser usage, use, launch, develop, or distribute any
                automated system, including without limitation, any spider,
                robot, cheat utility, scraper, or offline reader that accesses
                the Services, or use or launch any unauthorized script or other
                software.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Use a buying agent or purchasing agent to make purchases on the
                Services.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Make any unauthorized use of the Services, including collecting
                usernames and/or email addresses of users by electronic or other
                means for the purpose of sending unsolicited email, or creating
                user accounts by automated means or under false pretenses.
              </li>
              <li className="terms-body-text" style={{ lineHeight: 1.5 }}>
                Use the Services as part of any effort to compete with us or
                otherwise use the Services and/or the Content for any
                revenue-generating endeavor or commercial enterprise.
              </li>
            </ul>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="text-left">
            <div
              className="terms-heading-1"
              id="ugc"
              style={{ lineHeight: 1.5 }}
            >
              <strong>5. USER GENERATED CONTRIBUTIONS</strong>
            </div>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="text-left">
            <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
              <span
                style={{
                  fontSize: "11pt",
                  lineHeight: "16.8667px",
                  color: "rgb(89, 89, 89)",
                }}
              >
                The Services does not offer users to submit or post content. We
                may provide you with the opportunity to create, submit, post,
                display, transmit, perform, publish, distribute, or broadcast
                content and materials to us or on the Services, including but
                not limited to text, writings, video, audio, photographs,
                graphics, comments, suggestions, or personal information or
                other material (collectively, &quot;Contributions&quot;).
                Contributions may be viewable by other users of the Services and
                through third-party websites.
              </span>
            </div>
            <div style={{ lineHeight: 1.5 }}>
              <br />
            </div>
            <div
              className="terms-heading-1"
              id="license"
              style={{ lineHeight: 1.5 }}
            >
              <strong>6. CONTRIBUTION LICENSE</strong>
            </div>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "16.8667px",
                color: "rgb(89, 89, 89)",
              }}
            >
              You and Services agree that we may access, store, process, and use
              any information and personal data that you provide and your
              choices (including settings).
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "16.8667px",
                color: "rgb(89, 89, 89)",
              }}
            >
              By submitting suggestions or other feedback regarding the
              Services, you agree that we can use and share such feedback for
              any purpose without compensation to you.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "16.8667px",
                color: "rgb(89, 89, 89)",
              }}
            >
              We do not assert any ownership over your Contributions. You retain
              full ownership of all of your Contributions and any intellectual
              property rights or other proprietary rights associated with your
              Contributions. We are not liable for any statements or
              representations in your Contributions provided by you in any area
              on the Services. You are solely responsible for your Contributions
              to the Services and you expressly agree to exonerate us from any
              and all responsibility and to refrain from any legal action
              against us regarding your Contributions.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="sitemanage"
            style={{ lineHeight: 1.5 }}
          >
            <strong>7. SERVICES MANAGEMENT</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            We reserve the right, but not the obligation, to: (1) monitor the
            Services for violations of these Legal Terms; (2) take appropriate
            legal action against anyone who, in our sole discretion, violates
            the law or these Legal Terms, including without limitation,
            reporting such user to law enforcement authorities; (3) in our sole
            discretion and without limitation, refuse, restrict access to, limit
            the availability of, or disable (to the extent technologically
            feasible) any of your Contributions or any portion thereof; (4) in
            our sole discretion and without limitation, notice, or liability, to
            remove from the Services or otherwise disable all files and content
            that are excessive in size or are in any way burdensome to our
            systems; and (5) otherwise manage the Services in a manner designed
            to protect our rights and property and to facilitate the proper
            functioning of the Services.
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="terms"
            style={{ lineHeight: 1.5 }}
          >
            <strong>8. TERM AND TERMINATION</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "16.8667px",
                color: "rgb(89, 89, 89)",
              }}
            >
              These Legal Terms shall remain in full force and effect while you
              use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF THESE
              LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
              WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE
              SERVICES (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON
              FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR
              BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN
              THESE LEGAL TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY
              TERMINATE YOUR USE OR PARTICIPATION IN THE SERVICES OR DELETE ANY
              CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT
              WARNING, IN OUR SOLE DISCRETION.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "16.8667px",
                color: "rgb(89, 89, 89)",
              }}
            >
              If we terminate or suspend your account for any reason, you are
              prohibited from registering and creating a new account under your
              name, a fake or borrowed name, or the name of any third party,
              even if you may be acting on behalf of the third party. In
              addition to terminating or suspending your account, we reserve the
              right to take appropriate legal action, including without
              limitation pursuing civil, criminal, and injunctive redress.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="modifications"
            style={{ lineHeight: 1.5 }}
          >
            <strong>9. MODIFICATIONS AND INTERRUPTIONS</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "16.8667px",
                color: "rgb(89, 89, 89)",
              }}
            >
              We reserve the right to change, modify, or remove the contents of
              the Services at any time or for any reason at our sole discretion
              without notice. However, we have no obligation to update any
              information on our Services. We will not be liable to you or any
              third party for any modification, price change, suspension, or
              discontinuance of the Services.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "16.8667px",
                color: "rgb(89, 89, 89)",
              }}
            >
              We cannot guarantee the Services will be available at all times.
              We may experience hardware, software, or other problems or need to
              perform maintenance related to the Services, resulting in
              interruptions, delays, or errors. We reserve the right to change,
              revise, update, suspend, discontinue, or otherwise modify the
              Services at any time or for any reason without notice to you. You
              agree that we have no liability whatsoever for any loss, damage,
              or inconvenience caused by your inability to access or use the
              Services during any downtime or discontinuance of the Services.
              Nothing in these Legal Terms will be construed to obligate us to
              maintain and support the Services or to supply any corrections,
              updates, or releases in connection therewith.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-heading-1" id="law" style={{ lineHeight: 1.5 }}>
            <strong>10. GOVERNING LAW</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "16.8667px",
                color: "rgb(89, 89, 89)",
              }}
            >
              These Legal Terms shall be governed by and defined following the
              laws of the State of California. Midship Inc. and yourself
              irrevocably consent that the courts of California shall have
              exclusive jurisdiction to resolve any dispute which may arise in
              connection with these Legal Terms.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="disputes"
            style={{ lineHeight: 1.5 }}
          >
            <strong>11. DISPUTE RESOLUTION</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-heading-2" style={{ lineHeight: 1.5 }}>
            <strong>Informal Negotiations</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            To expedite resolution and control the cost of any dispute,
            controversy, or claim related to these Legal Terms (each a
            &quot;Dispute&quot; and collectively, the &quot;Disputes&quot;)
            brought by either you or us (individually, a &quot;Party&quot; and
            collectively, the &quot;Parties&quot;), the Parties agree to first
            attempt to negotiate any Dispute (except those Disputes expressly
            provided below) informally for at least thirty (30) days before
            initiating arbitration. Such informal negotiations commence upon
            written notice from one Party to the other Party.
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-heading-2" style={{ lineHeight: 1.5 }}>
            <strong>Binding Arbitration</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            Any dispute arising out of or in connection with these Legal Terms,
            including any question regarding its existence, validity, or
            termination, shall be referred to and finally resolved by the
            International Commercial Arbitration Court under the European
            Arbitration Chamber (Belgium, Brussels, Avenue Louise, 146)
            according to the Rules of this ICAC, which, as a result of referring
            to it, is considered as the part of this clause. The number of
            arbitrators shall be one (1). The seat, or legal place, or
            arbitration shall be San Francisco, California. The language of the
            proceedings shall be English. The governing law of these Legal Terms
            shall be substantive law of the State of California.
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-heading-2" style={{ lineHeight: 1.5 }}>
            <strong>Restrictions</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            The Parties agree that any arbitration shall be limited to the
            Dispute between the Parties individually. To the full extent
            permitted by law, (a) no arbitration shall be joined with any other
            proceeding; (b) there is no right or authority for any Dispute to be
            arbitrated on a class-action basis or to utilize class action
            procedures; and (c) there is no right or authority for any Dispute
            to be brought in a purported representative capacity on behalf of
            the general public or any other persons.
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-heading-2" style={{ lineHeight: 1.5 }}>
            <strong>Exceptions to Informal Negotiations and Arbitration</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            The Parties agree that the following Disputes are not subject to the
            above provisions concerning informal negotiations binding
            arbitration: (a) any Disputes seeking to enforce or protect, or
            concerning the validity of, any of the intellectual property rights
            of a Party; (b) any Dispute related to, or arising from, allegations
            of theft, piracy, invasion of privacy, or unauthorized use; and (c)
            any claim for injunctive relief. If this provision is found to be
            illegal or unenforceable, then neither Party will elect to arbitrate
            any Dispute falling within that portion of this provision found to
            be illegal or unenforceable and such Dispute shall be decided by a
            court of competent jurisdiction within the courts listed for
            jurisdiction above, and the Parties agree to submit to the personal
            jurisdiction of that court.
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="corrections"
            style={{ lineHeight: 1.5 }}
          >
            <strong>12. CORRECTIONS</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            There may be information on the Services that contains typographical
            errors, inaccuracies, or omissions, including descriptions, pricing,
            availability, and various other information. We reserve the right to
            correct any errors, inaccuracies, or omissions and to change or
            update the information on the Services at any time, without prior
            notice.
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="disclaimer"
            style={{ lineHeight: 1.5 }}
          >
            <strong>13. DISCLAIMER</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "115%",
                fontFamily: "Arial",
                color: "#595959",
              }}
            >
              THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
              AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO
              THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
              EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE
              THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
              NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT
              THE ACCURACY OR COMPLETENESS OF THE SERVICES&apos; CONTENT OR THE
              CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE
              SERVICES AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY
              (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS,
              (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
              RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES, (3) ANY
              UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND
              ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
              THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
              FROM THE SERVICES, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE
              LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY
              THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND
              MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A
              RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE
              MADE AVAILABLE VIA THE SERVICES. WE DO NOT WARRANT, ENDORSE,
              GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE
              ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SERVICES, ANY
              HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED
              IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO
              OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION
              BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES.
              AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR
              IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE
              CAUTION WHERE APPROPRIATE.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="liability"
            style={{ lineHeight: 1.5 }}
          >
            <strong>14. LIMITATIONS OF LIABILITY</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "115%",
                fontFamily: "Arial",
                color: "#595959",
              }}
            >
              <span className="terms-body-text">
                IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
                LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
                CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
                DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR
                OTHER DAMAGES ARISING FROM YOUR USE OF THE SERVICES, EVEN IF WE
                HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
              </span>{" "}
              <span className="terms-body-text">
                NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR
                LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE
                FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE LESSER
                OF THE AMOUNT PAID, IF ANY, BY YOU TO US.
              </span>{" "}
              <span className="terms-body-text">
                CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW
                LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION
                OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF
                THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND
                YOU MAY HAVE ADDITIONAL RIGHTS.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="indemnification"
            style={{ lineHeight: 1.5 }}
          >
            <strong>15. INDEMNIFICATION</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "115%",
                fontFamily: "Arial",
                color: "#595959",
              }}
            >
              You agree to defend, indemnify, and hold us harmless, including
              our subsidiaries, affiliates, and all of our respective officers,
              agents, partners, and employees, from and against any loss,
              damage, liability, claim, or demand, including reasonable
              attorneys&apos; fees and expenses, made by any third party due to
              or arising out of: (1) use of the Services; (2) breach of these
              Legal Terms; (3) any breach of your representations and warranties
              set forth in these Legal Terms; (4) your violation of the rights
              of a third party, including but not limited to intellectual
              property rights; or (5) any overt harmful act toward any other
              user of the Services with whom you connected via the Services.
              Notwithstanding the foregoing, we reserve the right, at your
              expense, to assume the exclusive defense and control of any matter
              for which you are required to indemnify us, and you agree to
              cooperate, at your expense, with our defense of such claims. We
              will use reasonable efforts to notify you of any such claim,
              action, or proceeding which is subject to this indemnification
              upon becoming aware of it.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="userdata"
            style={{ lineHeight: 1.5 }}
          >
            <strong>16. USER DATA</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "115%",
                fontFamily: "Arial",
                color: "#595959",
              }}
            >
              We will maintain certain data that you transmit to the Services
              for the purpose of managing the performance of the Services, as
              well as data relating to your use of the Services. Although we
              perform regular routine backups of data, you are solely
              responsible for all data that you transmit or that relates to any
              activity you have undertaken using the Services. You agree that we
              shall have no liability to you for any loss or corruption of any
              such data, and you hereby waive any right of action against us
              arising from any such loss or corruption of such data.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="electronic"
            style={{ lineHeight: 1.5 }}
          >
            <strong>
              17. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
            </strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "115%",
                fontFamily: "Arial",
                color: "#595959",
              }}
            >
              Visiting the Services, sending us emails, and completing online
              forms constitute electronic communications. You consent to receive
              electronic communications, and you agree that all agreements,
              notices, disclosures, and other communications we provide to you
              electronically, via email and on the Services, satisfy any legal
              requirement that such communication be in writing. YOU HEREBY
              AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND
              OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES,
              AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA
              THE SERVICES. You hereby waive any rights or requirements under
              any statutes, regulations, rules, ordinances, or other laws in any
              jurisdiction which require an original signature or delivery or
              retention of non-electronic records, or to payments or the
              granting of credits by any means other than electronic means.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="misc"
            style={{ lineHeight: 1.5 }}
          >
            <strong>18. MISCELLANEOUS</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "115%",
                fontFamily: "Arial",
                color: "#595959",
              }}
            >
              These Legal Terms and any policies or operating rules posted by us
              on the Services or in respect to the Services constitute the
              entire agreement and understanding between you and us. Our failure
              to exercise or enforce any right or provision of these Legal Terms
              shall not operate as a waiver of such right or provision. These
              Legal Terms operate to the fullest extent permissible by law. We
              may assign any or all of our rights and obligations to others at
              any time. We shall not be responsible or liable for any loss,
              damage, delay, or failure to act caused by any cause beyond our
              reasonable control. If any provision or part of a provision of
              these Legal Terms is determined to be unlawful, void, or
              unenforceable, that provision or part of the provision is deemed
              severable from these Legal Terms and does not affect the validity
              and enforceability of any remaining provisions. There is no joint
              venture, partnership, employment or agency relationship created
              between you and us as a result of these Legal Terms or use of the
              Services. You agree that these Legal Terms will not be construed
              against us by virtue of having drafted them. You hereby waive any
              and all defenses you may have based on the electronic form of
              these Legal Terms and the lack of signing by the parties hereto to
              execute these Legal Terms.
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div
            className="terms-heading-1"
            id="contact"
            style={{ lineHeight: 1.5 }}
          >
            <strong>19. CONTACT US</strong>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                fontSize: "11pt",
                lineHeight: "115%",
                fontFamily: "Arial",
                color: "#595959",
              }}
            >
              In order to resolve a complaint regarding the Services or to
              receive further information regarding use of the Services, please
              contact us at:
            </span>
          </div>
          <div style={{ lineHeight: 1.5 }}>
            <br />
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span style={{ color: "rgb(89, 89, 89)" }}>
              <strong>Midship Inc.</strong>
            </span>
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span
              style={{
                lineHeight: "115%",
                fontFamily: "Arial",
                color: "rgb(89, 89, 89)",
              }}
            >
              <strong>
                303 Sacramento St 3rd floor, San Francisco, CA 94111, USA
              </strong>
            </span>
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <span style={{ color: "rgb(89, 89, 89)" }}>
              <strong>SF, CA 94111</strong>
            </span>
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <strong>United States</strong>
          </div>
          <div className="terms-body-text" style={{ lineHeight: 1.5 }}>
            <strong>
              <a className="terms-link" href="mailto:founders@midship.ai">
                founders@midship.ai
              </a>
            </strong>
          </div>
        </div>
      </div>
    </div>
  );
}
